<script lang="ts" setup>

  defineProps<{
    label: string;
  }>();

</script>

<template>
  <div class="badge-zeppelin">
    {{ label }}
  </div>
</template>

<style lang="scss" scoped>
.badge-zeppelin {
  @include font-caption-sm;
  width: fit-content;
  color: inherit;
  height: fit-content;
  display: flex;
  align-items: center;
}

</style>
